module.exports = __webpack_public_path__ + "static/media/agodahomes-logo-icon.7dbfe4e9.png";